// extracted by mini-css-extract-plugin
export default {"layout":"layouts_layout__cP--K","spin":"layouts_spin__TLoEQ"};